import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import { createBrowserHistory } from "history";
import { routerReducer, routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import { reducer as modal } from "redux-modal";
import rootReducer from "reducers";

const initialState = {};
const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);
const middleware = [thunk, routeMiddleware];

const composedEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  combineReducers({
    ...rootReducer,
    modal,
    router: routerReducer
  }),
  initialState,
  composedEnhancers(applyMiddleware(...middleware))
);

export { store, history };
